module.exports = __webpack_public_path__ + "static/assets/1fdcebe394f42ecd9f40a2cee39cc11e.png";